import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiService } from '../services/api';
import { PublicForm } from '../types';

export function PublicFormPage() {
  const { slug = '' } = useParams();
  const [form, setForm] = useState<PublicForm | null>(null);
  const [answers, setAnswers] = useState<Record<string, string>>({});
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => { apiService.getPublicForm(slug).then(setForm).catch(() => setError('Formulario nao encontrado')); }, [slug]);

  async function submit(e: React.FormEvent) {
    e.preventDefault(); setError('');
    try {
      const result = await apiService.submitPublicForm(slug, answers);
      setMessage(result.message || 'Enviado com sucesso');
      if (result.redirectUrl) window.setTimeout(() => { window.location.href = result.redirectUrl!; }, 900);
    } catch (err: any) { setError(err.message); }
  }

  if (error && !form) return <div className="flex min-h-screen items-center justify-center bg-slate-50 text-slate-700">{error}</div>;
  if (!form) return <div className="flex min-h-screen items-center justify-center bg-slate-50 text-slate-700">Carregando...</div>;
  const theme = form.theme || {};
  const primary = theme.primaryColor || '#2563eb';

  return <div className="min-h-screen px-4 py-10" style={{ background: theme.backgroundColor || '#f8fafc', color: theme.textColor || '#0f172a', fontFamily: theme.fontFamily }}>
    <form onSubmit={submit} className="mx-auto max-w-xl rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
      {theme.logoUrl && <img src={theme.logoUrl} className="mb-5 h-14 max-w-[200px] object-contain" />}
      <h1 className="text-2xl font-semibold">{form.title}</h1>
      {form.description && <p className="mt-2 text-sm text-slate-600">{form.description}</p>}
      <div className="mt-6 space-y-4">
        {form.fields.map((field) => <label key={field.id} className="block text-sm font-medium">{field.label}{field.required ? ' *' : ''}
          {field.type === 'textarea' ? <textarea required={field.required} className="mt-1 h-28 w-full rounded-md border border-slate-300 px-3 py-2" value={answers[field.id] || ''} onChange={e => setAnswers({ ...answers, [field.id]: e.target.value })} /> :
          field.type === 'select' ? <select required={field.required} className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2" value={answers[field.id] || ''} onChange={e => setAnswers({ ...answers, [field.id]: e.target.value })}><option value="">Selecione</option>{(field.options || []).map(o => <option key={o}>{o}</option>)}</select> :
          <input required={field.required} type={field.type === 'phone' ? 'tel' : field.type} className="mt-1 w-full rounded-md border border-slate-300 px-3 py-2" value={answers[field.id] || ''} onChange={e => setAnswers({ ...answers, [field.id]: e.target.value })} />}
        </label>)}
      </div>
      {error && <div className="mt-4 rounded-md bg-red-50 p-3 text-sm text-red-700">{error}</div>}
      {message && <div className="mt-4 rounded-md bg-emerald-50 p-3 text-sm text-emerald-700">{message}</div>}
      <button className="mt-6 w-full rounded-md px-4 py-3 text-sm font-semibold text-white" style={{ background: primary }}>{form.buttonText}</button>
    </form>
  </div>;
}
